import { Code } from './code.js'

export * from './code.js'

export default Code
